import { useQuery } from "@tanstack/react-query";
import { api } from "../../data";
import { loadDemoMarks, loadAgentur, loadAgenturVertrieb, loadAgenturen, loadClientErrors, loadDeletions, loadLifecycleLog, loadMailHealth, loadOpsStatus, loadRequests, loadSenderDomains, loadSetup, loadStorageCleanup, loadSupport } from "./data";

/** Abfragen der Betreiber-Konsole. Schlüssel mit „betrieb“, damit sie den Cache anderer Gruppen nicht füllen. */
const KEY = "betrieb";

export const useAgenturen = () =>
  useQuery({ queryKey: ["platform_org_overview", "alle", KEY], queryFn: () => loadAgenturen(api) });

/** Kundenakte: der Admin mit Abo, Stripe-Ereignissen und Support, der Vertrieb nur mit den Zählwerten (0459) */
export const useAgentur = (orgId: string, rolle: "developer" | "admin" | "sales" = "admin") =>
  useQuery({ queryKey: ["platform_org_overview", orgId, KEY, rolle === "sales" ? "sales" : "admin"], queryFn: () => (rolle !== "sales" ? loadAgentur(api, orgId) : loadAgenturVertrieb(api, orgId)) });

export const useSupport = () =>
  useQuery({ queryKey: ["support_access_grants", "alle", KEY], queryFn: () => loadSupport(api) });

export const useRequests = (orgId: string | null = null) =>
  useQuery({ queryKey: ["subscription_requests", orgId ?? "alle", KEY], queryFn: () => loadRequests(api, orgId) });
export const useDeletions = () =>
  useQuery({ queryKey: ["account_deletion_requests", "alle", KEY], queryFn: () => loadDeletions(api) });
export const useLifecycleLog = () =>
  useQuery({ queryKey: ["platform_lifecycle_log", "alle", KEY], queryFn: () => loadLifecycleLog(api) });

/** Nur während einer begonnenen Sitzung mit gültigem Zugang. */
export const useSetup = (orgId: string | null) =>
  useQuery({ queryKey: ["org_setup_status", orgId, KEY], enabled: !!orgId, queryFn: () => loadSetup(api, orgId!), retry: false });

/** Betrieb (0101): Zeitpläne, Serverfunktionen, Mailversand; alle zwei Minuten frisch. */
export const useOpsStatus = () =>
  useQuery({ queryKey: ["platform_ops_status", "alle", KEY], queryFn: () => loadOpsStatus(api), refetchInterval: 120_000 });
/** Eigene Absenderdomains der Agenturen (0102). */
export const useSenderDomains = () =>
  useQuery({ queryKey: ["platform_sender_domains", "alle", KEY], queryFn: () => loadSenderDomains(api) });
/** Speicher aufräumen (0103). */
export const useStorageCleanup = () =>
  useQuery({ queryKey: ["platform_lifecycle_log", "speicher", KEY], queryFn: () => loadStorageCleanup(api) });
/** Zustellbarkeit (0104). */
export const useMailHealth = () =>
  useQuery({ queryKey: ["platform_mail_health", "alle", KEY], queryFn: () => loadMailHealth(api), refetchInterval: 120_000 });
/** Fehler im Browser (0158); alle zwei Minuten frisch wie der Stand des Betriebs. */
export const useClientErrors = () =>
  useQuery({ queryKey: ["platform_client_errors", "alle", KEY], queryFn: () => loadClientErrors(api), refetchInterval: 120_000 });
/** 0390: „Demo gebucht“ je Agentur (Agenturliste und Agentur-Detail) */
export const useDemoMarks = () =>
  useQuery({ queryKey: ["platform_demo_marks", "alle", KEY], queryFn: () => loadDemoMarks(api) });
